import React from 'react';
import { Link } from 'react-router-dom';

// Importing images
import FooterLogo from '../../assets/images/footer-logo-light.svg';
import ArrowLink from '../../assets/images/svg/arrow-link.svg';
import FooterMail from '../../assets/images/svg/footer-two/footer-two-mail.svg';
import FooterAddress from '../../assets/images/svg/footer-two/footer-two-address.svg';
import FooterCall from '../../assets/images/svg/footer-two/footer-two-call.svg';
import FooterC1 from '../../assets/images/svg/footer-two/footer-two-c-1.svg';
import FooterC2 from '../../assets/images/svg/footer-two/footer-two-c-2.svg';
import FooterC3 from '../../assets/images/svg/footer-two/footer-two-c-3.svg';
import FooterC4 from '../../assets/images/svg/footer-two/footer-two-c-4.svg';
import FooterC5 from '../../assets/images/svg/footer-two/footer-two-c-5.svg';
import FooterOne1 from '../../assets/images/footer-icon/footer-one-1.svg';
import FooterOne2 from '../../assets/images/footer-icon/footer-one-2.svg';
import FooterOne3 from '../../assets/images/footer-icon/footer-one-3.svg';
import FooterOne4 from '../../assets/images/footer-icon/footer-one-4.svg';
import FooterOne5 from '../../assets/images/footer-icon/footer-one-5.svg';
import FooterOne6 from '../../assets/images/footer-icon/footer-one-6.svg';
import FooterOne7 from '../../assets/images/footer-icon/footer-one-7.svg';
import FooterOne8 from '../../assets/images/footer-icon/footer-one-8.svg';
import FooterOne9 from '../../assets/images/footer-icon/footer-one-9.svg';
import FooterOne10 from '../../assets/images/footer-icon/footer-one-10.svg';
import InstaIcon from '../../assets/images/svg/header/Insta.svg';
import TwitterIcon from '../../assets/images/svg/header/Twiter.svg';
import PinterestIcon from '../../assets/images/svg/header/Pintrest.svg';

const Footer2 = () => {
    return (
        <>
            <footer className="footer-section-two">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="footer-logo-two zoomIn wow" data-wow-duration="2000ms">
                                <Link to="/">
                                    <img src={FooterLogo} alt="logo" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="newslatter-two zoomIn wow" data-wow-duration="2000ms">
                                <form action="#">
                                    <div className="newslatter-form-group-two">
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="enter your email"
                                            required
                                        />
                                        <button type="submit">
                                            <img src={ArrowLink} alt="icon" />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="footer-about-two animate fadeInRight wow" data-wow-duration="1500ms">
                                <h4>About Uniqo</h4>
                                <p>Over the past three years, marketers have faced an arduous journey.</p>
                                <ul className="footer-about-list-two">
                                    <li>
                                        <span>
                                            <img src={FooterMail} alt="icon" />
                                        </span>
                                        <Link to="mailto:needhelp@company.com">needhelp@company.com</Link>
                                    </li>
                                    <li>
                                        <span>
                                            <img src={FooterAddress} alt="icon" />
                                        </span>
                                        <p>135 klf, Hotland, USA</p>
                                    </li>
                                    <li>
                                        <span>
                                            <img src={FooterCall} alt="icon" />
                                        </span>
                                        <Link to="telto:1-888-452-1505">1-888-452-1505</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="footer-widget-two animate fadeInRight wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                <h4>Company</h4>
                                <ul className="footer-menu-two">
                                    <li>
                                        <img src={FooterC1} alt="icon" />
                                        <Link to="/ServiceDetails">Financial Analysis</Link>
                                    </li>
                                    <li>
                                        <img src={FooterC2} alt="icon" />
                                        <Link to="/ServiceDetails">Market Research</Link>
                                    </li>
                                    <li>
                                        <img src={FooterC3} alt="icon" />
                                        <Link to="/ServiceDetails">Competitive Analysis</Link>
                                    </li>
                                    <li>
                                        <img src={FooterC4} alt="icon" />
                                        <Link to="/ServiceDetails">Team Building</Link>
                                    </li>
                                    <li>
                                        <img src={FooterC5} alt="icon" />
                                        <Link to="/ServiceDetails">HR Management</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="footer-widget-two animate fadeInRight wow" data-wow-duration="1500ms" data-wow-delay="400ms">
                                <h4>Services</h4>
                                <ul className="footer-menu-two">
                                    <li>
                                        <img src={FooterOne1} alt="icon" />
                                        <Link to="/ServiceDetails">Financial Analysis</Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne2} alt="icon" />
                                        <Link to="/ServiceDetails">Work organization</Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne3} alt="icon" />
                                        <Link to="/ServiceDetails">Digital Marketing</Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne4} alt="icon" />
                                        <Link to="/ServiceDetails">Innovation space</Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne5} alt="icon" />
                                        <Link to="/ServiceDetails">Risk Advisory</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="footer-widget-two animate fadeInRight wow" data-wow-duration="1500ms" data-wow-delay="600ms">
                                <h4>Pages</h4>
                                <ul className="footer-menu-two">
                                    <li>
                                        <img src={FooterOne6} alt="icon" />
                                        <Link to="/Aboutus">About</Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne7} alt="icon" />
                                        <Link to="/Careers">Career </Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne8} alt="icon" />
                                        <Link to="/Aboutus">Applications</Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne9} alt="icon" />
                                        <Link to="/Contact">Contact Us</Link>
                                    </li>
                                    <li>
                                        <img src={FooterOne10} alt="icon" />
                                        <Link to="/Portfolio">Case Studies</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="footer-lower-two animate zoomIn wow" data-wow-duration="1500ms">
                                <p className="lead">© Copyright@ Uniqo All rights reserved</p>
                                <ul>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <img src={InstaIcon} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <img src={TwitterIcon} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.pinterest.com/">
                                            <img src={PinterestIcon} alt="icon" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer2;
